import React, { Component } from 'react'
import './App.css'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
//import { withRouter } from 'react-router-dom'
//import { connect } from 'react-redux'
import AppStore from './AppStore'
import vhCheck from './utils/vhCheck'
import Routes from './routes/Routes'


// set --vh-offset css variable to fix vh in iOS
const isNeeded  = vhCheck()
console.log('vh-check isNeeded:', isNeeded)


class App extends Component {

  constructor(props) {
    super(props)
    if (AppStore.isLoaded) {
      this.setState({isLoading: false})
    } else {
      AppStore.on('load', () => this.setState({isLoading: false}))
    }
    this.state = {
      isLoading: true,
      store: AppStore.store,
    }
  }

  render() {
    if (this.state.isLoading) {
      return null
    }
    return (
      <Provider store={this.state.store}>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js